import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import "./Sadguru_arpanam_event_join_form.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Light_Black_Btn from "../../common/common_btn/light_black_btn/Light_Black_Btn";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import Breadcrumb_Comp from "../../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Back_Header from "../../common/common_components/common_back_header/Common_Back_Header";
import Success_Modal from "../../common/common_modal/success_modal/Success_Modal";
import Successfull_Modal from "../../common/modals/common-modal/successfull_modal/Successfull_Modal";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";

const Sadguru_arpanam_event_join_form = () => {
  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const breadcrumbs = [
    {
      label: "BACK",
      link: "/sadguru-arpanam",
      active: true,
    },
  ];

  const [successModal, setSuccessModal] = useState(false);
  const [arrivalTime, setArrivalTime] = useState(null);
  const [departureTime, setDepartureTime] = useState(null);

  return (
    <>
      <section className="Sadguru_arpanam_event_join_form">
        <div className="container">
          <div className="form_div">
            <div className="row">
              <div className="col-lg-12 mx-auto">
                {/* <Breadcrumb_Comp data={breadcrumbs} /> */}
                <Common_Back_Header backNavigation={-1} />
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <Form.Label>Full Name of Participant*</Form.Label>
                      <Form.Control type="text" placeholder="Enter Full Name" />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>WhatsApp Number*</Form.Label>
                      <Controller
                        name="number"
                        control={control}
                        defaultValue=""
                        placeholder="Enter Mobile Number"
                        rules={{
                          required: "Mobile number is required",
                          pattern: {
                            value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{4})[-. )]*(\d{4})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                            message: "Number must be 10 digit",
                          },
                        }}
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            country={"in"}
                            value={"919822956771"}
                            placeholder="Enter Mobile Number"
                            onChange={onChange}
                            inputProps={{
                              name: "number",
                              required: true,
                              autoFocus: true,
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Alternate Phone Number</Form.Label>
                      <Controller
                        name="number"
                        control={control}
                        defaultValue=""
                        placeholder="Enter Mobile Number"
                        rules={{
                          required: "Mobile number is required",
                          pattern: {
                            value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{4})[-. )]*(\d{4})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                            message: "Number must be 10 digit",
                          },
                        }}
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            country={"in"}
                            value={"919822956771"}
                            placeholder="Enter Mobile Number"
                            onChange={onChange}
                            inputProps={{
                              name: "number",
                              required: true,
                              autoFocus: true,
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Gender*</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="country_id"
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.country_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={countries}
                          />
                        )}
                      />
                    </div>
                  </div>

                  {/* <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Date of Birth*</Form.Label>
                      <Form.Control type="date" placeholder="Enter Full Name" />
                    </div>
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Date of Birth*</Form.Label>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Controller
                          name="date_of_birth"
                          control={control}
                          rules={{ required: "Date of Birth is required" }}
                          render={({ field }) => (
                            <DatePicker
                              value={field.value ? dayjs(field.value) : null}
                              onChange={(newValue) =>
                                field.onChange(
                                  newValue
                                    ? newValue.format("YYYY-MM-DD")
                                    : null,
                                )
                              }
                              maxDate={dayjs()} // disable future dates
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: !!errors?.date_of_birth,
                                  helperText: errors?.date_of_birth?.message,
                                  placeholder: "Select Date of Birth",
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </div>

                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <Form.Label>Email*</Form.Label>
                      <Form.Control type="text" placeholder="Enter Email" />
                    </div>
                  </div>

                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <Form.Check
                        type="checkbox"
                        name="name"
                        label="Is this the same address as above?"
                        id="second"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Country Of Residence*</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="country_id"
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.country_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={countries}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Postal Code"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>City</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="country_id"
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.country_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={countries}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>State</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="country_id"
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.country_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={countries}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter Address"
                      />
                    </div>
                  </div>

                  {/* <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Date of Arrival*</Form.Label>
                      <Form.Control type="date" />
                    </div>
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Date of Arrival*</Form.Label>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Controller
                          name="arrival_date"
                          control={control}
                          rules={{
                            required: "Arrival date is required",
                          }}
                          render={({ field }) => (
                            <DatePicker
                              label="Select Arrival Date"
                              value={field.value ? dayjs(field.value) : null}
                              onChange={(newValue) => {
                                const formattedDate = newValue
                                  ? newValue.format("YYYY-MM-DD")
                                  : null;
                                field.onChange(formattedDate);
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: !!errors?.arrival_date,
                                  helperText: errors?.arrival_date?.message,
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </div>

                  {/* <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Date of Departure*</Form.Label>
                      <Form.Control type="date" />
                    </div>
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Date of Departure*</Form.Label>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Controller
                          name="departure_date"
                          control={control}
                          rules={{
                            required: "Departure date is required",
                          }}
                          render={({ field }) => (
                            <DatePicker
                              label="Select Departure Date"
                              value={field.value ? dayjs(field.value) : null}
                              onChange={(newValue) => {
                                const formattedDate = newValue
                                  ? newValue.format("YYYY-MM-DD")
                                  : null;
                                field.onChange(formattedDate);
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: !!errors?.departure_date,
                                  helperText: errors?.departure_date?.message,
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </div>

                  <div className="col-md-6 mb-3">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Time of Departure</Form.Label>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Select Departure Time"
                          value={departureTime}
                          onChange={(newValue) => setDepartureTime(newValue)}
                          slotProps={{
                            textField: { fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </div>

                  <div className="col-md-6 mb-3">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Time of Departure</Form.Label>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Select Departure Time"
                          value={departureTime}
                          onChange={(newValue) => setDepartureTime(newValue)}
                          slotProps={{
                            textField: { fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>
                        Looking for a peaceful stay at the Ashram?
                      </Form.Label>
                      <Form.Check
                        type="radio"
                        name="name"
                        label="Yes, I would love to stay at the Ashram and experience its peace and divinity"
                        id="first"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label></Form.Label>
                      <Form.Check
                        type="radio"
                        name="name"
                        label="Yes, I would love to stay at the Ashram and experience its peace and divinity"
                        id="second"
                      />
                    </div>
                  </div>

                  <div className="col-md-12 mb-3">
                    <div className="akknwdiv">
                      <Form.Check
                        type="checkbox"
                        name="name"
                        label="I acknowledge that this experience is for personal growth and is not a medical substitute."
                        id="second"
                      />
                      <p className="disclamer">
                        <span>Disclaimer: </span>The practices and teachings
                        offered through this program are rooted in ancient yogic
                        wisdom & are intended to support personal well-being,
                        spiritual growth, & inner balance. They are not a
                        substitute for professional medical or psychological
                        treatment
                      </p>
                    </div>

                    <div className="submitbtns">
                      <Light_Black_Btn btnText={"Add another participate"} />
                      <br></br>
                      <Pink_Btn
                        btnText={"Submit"}
                        onClick={() => setSuccessModal(true)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Successfull_Modal
          show={successModal}
          onHide={() => setSuccessModal(false)}
          headtext={"Joined to Sadguru Arpanam"}
          successfultext={
            "Joined Sadguru Arpanam Successfully! We will notify you about event!"
          }
          subtext={
            "Stay connected for divine updates and Sadguru’s grace-filled gatherings."
          }
        />
      </section>
    </>
  );
};

export default Sadguru_arpanam_event_join_form;
